import { Controller } from "@hotwired/stimulus"

// Appends/toggles a SORT pipe to the ES|QL query when a column header is clicked.
export default class extends Controller {
  static values = { column: String }

  sort() {
    const col = this.columnValue
    if (!col) return

    const textarea = document.querySelector("textarea[name='query']")
    if (!textarea) return

    const current = textarea.value.trim()
    const sortClause = this.#nextSortClause(current, col)

    textarea.value = this.#replaceSortPipe(current, col, sortClause)
    textarea.dispatchEvent(new Event("input", { bubbles: true }))

    const form = textarea.closest("form")
    if (form) form.requestSubmit()
  }

  #nextSortClause(query, col) {
    const escaped = col.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    const existing = query.match(new RegExp(`\\|\\s*sort\\s+${escaped}\\s+(ASC|DESC)`, "i"))
    if (!existing) return `| sort ${col} DESC`
    return existing[1].toUpperCase() === "DESC" ? `| sort ${col} ASC` : `| sort ${col} DESC`
  }

  #replaceSortPipe(query, col, newClause) {
    const escaped = col.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    const sortRx = new RegExp(`\\s*\\|\\s*sort\\s+${escaped}\\s+(ASC|DESC)`, "gi")
    if (sortRx.test(query)) {
      return query.replace(sortRx, `\n${newClause}`)
    }
    return `${query}\n${newClause}`
  }
}
